import ContactInfo from './contact-info';
export default ContactInfo;
